import { Link } from 'react-router-dom';
import type { GsEvent } from '@/lib/types';
import { fallbackHero } from '@/lib/placeholders';
import { formatEventDate } from '@/lib/format';
import DemoBadge from '@/components/feature/DemoBadge';

export default function EventHero({ event }: { event: GsEvent }) {
  const dateText = formatEventDate(event.event_date)
    || [event.weekday, event.month_label, event.day_label, event.year_label].filter(Boolean).join(' ');

  return (
    <section className="relative h-[460px] md:h-[620px] flex items-end">
      <img
        src={event.hero_image || fallbackHero}
        alt={event.name}
        title={`${event.name}, ${event.city}`}
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/40 to-foreground-950/30"></div>
      <div className="relative w-full px-4 md:px-8 pb-10 md:pb-16">
        <Link to="/calendar" className="gs-rise inline-flex items-center gap-2 text-background-200 hover:text-background-50 font-label font-semibold uppercase tracking-wider text-sm mb-4 cursor-pointer">
          <span className="w-5 h-5 flex items-center justify-center"><i className="ri-arrow-left-line"></i></span>All tournaments
        </Link>
        <div className="flex flex-wrap items-center gap-2">
          <span className="gs-rise inline-block bg-accent-500 text-foreground-950 font-label font-bold uppercase text-xs tracking-widest px-3 py-1.5 rounded-sm">
            {event.event_type} tournament{event.city ? `, ${event.city}` : ''}
          </span>
          {event.is_demo && <span className="gs-rise"><DemoBadge label="Sample tournament" /></span>}
        </div>
        <h1 className="gs-rise-2 mt-4 font-heading font-extrabold uppercase text-4xl md:text-7xl text-background-50 leading-[0.92] max-w-5xl">{event.name}</h1>
        {dateText && <p className="gs-rise-3 mt-4 text-background-200 font-label uppercase tracking-widest text-sm">{dateText}</p>}
      </div>
    </section>
  );
}